import {Component, OnInit} from '@angular/core';
import {
  TuiButtonModule,
  TuiErrorModule,
  TuiSvgModule,
  TuiLoaderModule,
  TuiAlertService,
  TuiDialogService
} from '@taiga-ui/core';
import {Router} from "@angular/router";
import {TUI_PROMPT, TuiPaginationModule, TuiPromptData} from "@taiga-ui/kit";
import {PageSize} from "../../core/dto/page.size";
import {Pagination} from "../../core/dto/pagination";
import {AnnouncementService} from "../../core/services/announcement.service";
import {NgForOf, NgIf} from "@angular/common";
import {SETTINGS} from "../../core/config/common.settings";
@Component({
  selector: 'app-announcements',
  standalone: true,
  imports: [
    TuiButtonModule,
    TuiErrorModule,
    TuiSvgModule,
    TuiLoaderModule,
    TuiPaginationModule,
    NgForOf,
    NgIf,
  ],
  providers: [
    AnnouncementService
  ],
  templateUrl: './announcements.component.html',
  styleUrl: './announcements.component.scss'
})
export class AnnouncementsComponent implements OnInit{
  isLoading = false;
  pageSize = new PageSize({pageSize: 5});
  announcementData: any[] = [];

  constructor(private router: Router,
              private announcementService: AnnouncementService,
              private readonly alerts: TuiAlertService,
              private readonly dialogs: TuiDialogService,) {
  }

  ngOnInit() {
    this.getPaginatedAnnouncement();
  }

  async getPaginatedAnnouncement(): Promise<void> {
    this.isLoading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {});
    try {
      const res = await this.announcementService.getPagedAnnouncement(payload)
      this.announcementData = res[0].data;
      this.pageSize.length = Math.ceil(res[0].metadata[0].total / this.pageSize.pageSize)
      this.isLoading = false;
    } catch (e: any) {
      this.isLoading = false;
    }
  }
  deleteAnnouncement(id: string): void {
    const data: TuiPromptData = {
      content:
        `Are you sure you want to delete`,
      yes: 'Yes',
      no: 'Cancel',
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        size: 's',
        data,
      })
      .subscribe(response => {
        if (response) {
          this.isLoading = true;
          this.announcementService.softDeleteAnnouncement(id).then(() => {
            this.alerts.open('<p style="color: red">Announcement Deleted Successfully</p>').subscribe();
            this.getPaginatedAnnouncement();
          }).catch((e: any) => {
            this.alerts.open(`<p style="color: red">Unable to delete announcement. Please try again later.</p>`, { status: 'error' }).subscribe();
            this.isLoading = false;
          });
        }
      });
  }
  sendAnnouncement(id: string): void {
    const data: TuiPromptData = {
      content:
        `Are you sure you want to send`,
      yes: 'Yes',
      no: 'Cancel',
    };

    this.dialogs
      .open<boolean>(TUI_PROMPT, {
        size: 's',
        data,
      })
      .subscribe(response => {
        if (response) {
          this.isLoading = true;
          this.announcementService.sendAnnouncement(id).then(() => {
            this.alerts.open('<p style="color: red">Announcement Send Successfully</p>').subscribe();
            this.getPaginatedAnnouncement();
          }).catch((e: any) => {
            this.alerts.open(`<p style="color: red">Unable to send announcement. Please try again later.</p>`, { status: 'error' }).subscribe();
            this.isLoading = false;
          });
        }
      });
  }
  // async sendAnnouncement(id: string): Promise<void> {
  //   this.isLoading = true;
  //   try {
  //     const res = await this.announcementService.sendAnnouncement(id)
  //     this.alerts.open('<p style="color: red">Announcement Send Successfully</p>').subscribe();
  //     this.getPaginatedAnnouncement();
  //   } catch (e: any) {
  //     this.alerts.open(`<p style="color: red">${e.message}</p>`, { status: 'error' }).subscribe();
  //     this.isLoading = false;
  //   }
  // }
  getRecipientLabel(recipient: string) {
    return recipient ? (SETTINGS.ANNOUNCEMENT_RECIPIENT.find((val: any) => recipient === val.value))?.label : ""
  }
  goToPage(event: any): void {
    this.pageSize.pageIndex = event + 1;
    this.getPaginatedAnnouncement();
  }
  navigateToAdd(): void {
    this.router.navigate(['admin/announcement/add-edit'])
  }
}
